export default __webpack_public_path__ + "static/media/sustainDigitalLogo.9dabee83.png";